<template>
  <div class="tabcontent">
    <v-row justify="space-between">
      <v-col cols="12" md="8" sm="12">
        <v-form ref="form" v-model="valid">
          <v-row :dense="true">
            <v-col cols="12" md="4">
              <v-subheader>Получатель</v-subheader>
            </v-col>
            <v-col cols="12" md="8">
              <v-skeleton-loader
                  :loading="loading"
                  type="list-item"
                  class="mx-auto"
              >
                <v-combobox
                    v-model="IdOrg"
                    :items="orglist"
                    :dense="true"
                    required
                ></v-combobox>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row :dense="true">
            <v-col cols="12" md="4">
              <v-subheader>Плательщик</v-subheader>
            </v-col>
            <v-col cols="12" md="8">
              <v-skeleton-loader
                  :loading="loading"
                  type="list-item"
                  class="mx-auto"
              >
                <v-combobox
                    v-model="IdSender"
                    :items="kontragentlist"
                    :dense="true"
                    required
                ></v-combobox>
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row :dense="true">
            <v-col cols="12" md="4">
              <v-subheader>Плановая дата платежа</v-subheader>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                      v-model="PlanDate"
                      hint="ДД.ММ.ГГГГ"
                      persistent-hint
                      v-bind="attrs"
                      @blur="date = parseDate(PlanDate)"
                      v-on="on"
                      :dense="true"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" first-day-of-week="1" no-title @input="menu1 = false" required></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row :dense="true">
            <v-col cols="12" md="4">
              <v-subheader>Статья бюджета</v-subheader>
            </v-col>
            <v-col cols="12" md="8">
              <v-skeleton-loader
                  :loading="loading"
                  type="list-item"
                  class="mx-auto"
              >
                <v-combobox
                    v-model="IdStatii"
                    :items="staiilist"
                    :dense="true"
                   required
                ></v-combobox>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row :dense="true">
            <v-col cols="12" md="4">
              <v-subheader>Сумма</v-subheader>
            </v-col>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                  v-model="Summa"
                  :counter="10"
                  :rules="summaRules"
                  :dense="true"
                  required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row :dense="true">
            <v-col cols="12" md="4">
              <v-subheader>Основание</v-subheader>
            </v-col>
            <v-col cols="12" md="8">
              <v-textarea
                  v-model="Osnovanie"
                  counter="255"
                  rows="2"
                  :dense="true"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row :dense="true">
            <v-col cols="12" md="4">
            </v-col>
            <v-col cols="12" md="8">
              <v-checkbox :dense="true" v-model="StateOp" label="Поступило"></v-checkbox>
            </v-col>
          </v-row>
          <input type="hidden" v-model="id">
          <v-row :dense="true">
            <v-col cols="12" md="4"></v-col>
            <v-col cols="12" md="8">
              <v-btn color="primary" class="mr-4" @click="savePalnPost"
                     :disabled="false"
              >
                Сохранить
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar
        v-model="snackbarresult"
        :timeout="resulttimeout"
    >
      {{ resulttext }}
    </v-snackbar>
  </div>
</template>

<script>
  import {bus} from "@/plugins/bus";

  export default {
    name: "PlanPostAdd",
    props: ['id', 'IdOrgDef'],
    mounted() {
      this.IdZayavitel = localStorage.getItem('user-id');
      this.loadData();

      bus.$on('refreshTabPlanPostAdd'+this.$props.id, this.refreshHandler);
    },
    data() {
      return {
        loading: true,
        IdOrg: '',
        valid: true,
        IdZayavitel: 0,
        IdStatii: null,
        Summa: 0.00,
        PlanDate: '',
        IdSender: '',
        Osnovanie: '',
        file: null,
        fileexist: '',
        filelink: '',
        date: new Date().toISOString().substr(0, 10),
        menu1: false,
        houses: [],
        StateOp: 0,
        statelist: ['Ожидает', 'Поступило'],
        snackbarresult: false,
        resulttimeout: 2000,
        resulttext: ''
      }
    },
    computed: {
      kontragentlist() {
        let ret = [];
        let kontragents = this.$store.getters.ZAYAVKIFILTERS ? this.$store.getters.ZAYAVKIFILTERS.kontragents : null;
        if (kontragents) {
          kontragents.forEach((item) => {
            ret.push({text: item.Name, value: item.ID});
          });
        }
        return ret;
      },
      orglist() {
        let ret = [];
        if (this.$store.getters.ZAYAVKIFILTERS) {
          this.$store.getters.ZAYAVKIFILTERS.orglist.forEach((item) => {
            ret.push({text: item.Name, value: item.ID});
          });
        }
        return ret;
      },
      summaRules() {
        const rules = [];
        let rule = v => !!v || 'Введите сумму';
        rules.push(rule);
        rule = v => (v && v.length <= 10) || 'Сумма не более 10 символов';
        rules.push(rule);
        return rules;
      },
      staiilist() {
        let ret = [];
        let staiilist = this.$store.getters.ZAYAVKIFILTERS ? this.$store.getters.ZAYAVKIFILTERS.staiilist : null;
        if (staiilist) {
          // eslint-disable-next-line no-unused-vars
          Object.entries(staiilist).forEach(([key, item]) => {
            if (item.Type == 0) {
              if (item.Name) {
                ret.push({header: item.Name});
              }
              item.sub.forEach((itemst) => {
                //console.log(itemst);

                ret.push({text: itemst.Name, value: itemst.ID, houses: itemst.Houses, all: itemst.All});
                itemst.sub.forEach((itemsub) => {

                  ret.push({
                    text: ' - ' + itemsub.Name,
                    value: itemsub.ID,
                    houses: itemsub.Houses,
                    all: itemst.All
                  });

                });

              });
            }
          });
        }
        return ret;
      },
    },
    watch: {
      date () {
        this.PlanDate = this.formatDate(this.date);
      }
    },
    methods: {
      formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}.${month}.${year}`;
      },
      parseDate(date) {
        if (!date) return null;

        const [day, month, year] = date.split('.');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
      formatCurrency(value) {
        let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
        return formatter.format(value / 1);
      },
      fromCurrency(value) {
        if (!value) return 0;
        value = value.replace(/\s/, '');
        value = value.replace(/,/, '.');
        return parseFloat(value);
      },
      loadData() {
        this.$store.dispatch('GET_ZAYAVKIFILETRS', {IdOrg: this.IdOrg ? this.IdOrg.value : 0, Date: this.date}).then(() => {
          if (this.$props.id > 0) {
            this.$store.dispatch('EDIT_PLANPOSTUPLEN', {id: this.$props.id})
                .then(response => {
                  for (let item of this.orglist) {
                    if (item.value == response.data.IdOrg) {
                      this.IdOrg = item;
                      break;
                    }
                  }

                  for (let item of this.kontragentlist) {
                    if (item.value == response.data.IdSender) {
                      this.IdSender = item;
                      break;
                    }
                  }

                  for (let item of this.staiilist) {
                    if (item.value === response.data.IdStatiObject) {
                      this.IdStatii = item;
                      break;
                    }
                  }

                  this.StateOp = parseInt(response.data.StateOp);
                  this.Summa = this.formatCurrency(response.data.Summa);
                  this.date = response.data.PlanDate;
                  this.Osnovanie = response.data.Osnovanie;
                  this.fileexist = response.fileexist;
                  this.filelink = response.filelink;
                  this.loading = false;
                });
          } else {
            this.$refs.form.reset();
            this.IdStatii = '';
            this.IdSender = '';
            this.houses = [];
            this.loading = false;
          }
        });
      },
      refreshHandler() {
        this.loadData();
      },
      savePalnPost() {
        let res;
        if (!this.$refs.form.validate() ||
            !this.IdStatii || !this.IdOrg || !this.IdSender ||
            this.PlanDate === '' || this.PlanDate === undefined ||
            this.fromCurrency(this.Summa) <= 0
        ) {
          this.resulttext = 'Заполните форму поступления!';
          this.snackbarresult = true;
          return;
        }

        const data = {
          IdStatiObject: this.IdStatii.value,
          Summa: this.fromCurrency(this.Summa),
          PlanDate: this.PlanDate,
          IdOrg: this.IdOrg.value,
          IdSender: this.IdSender.value,
          Osnovanie: this.Osnovanie,
          StateOp: this.StateOp
        };
        if (this.$props.id > 0) {
          data['ID'] = this.id;
          res = this.$store.dispatch('UPDATE_PLANPOSTUPLEN', data);
        } else {
          res = this.$store.dispatch('SAVE_PLANPOSTUPLEN', data);
        }
        res.then(response => {
          //console.log(this.$vnode.key);
          if (response.status === 1) {
            this.$parent.closeTab(this.$vnode.key, 'tabPlanPostuplen0');
            bus.$emit('resetFilterhPlanPostuplen', {IdOrg: this.IdOrg.value});
          } else {
            this.resulttext = response.message;
            this.snackbarresult = true;
          }
        });
      }
    },
    filters: {
      toCurrency: function (value) {
        if (value === undefined) value = 0;
        let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
        return formatter.format(value/1);
      },
      toDate: function (value) {
        if (!value) return '';
        const [year, month, day] = value.split('-');
        return `${day}.${month}.${year}`;
      }
    }
  }
</script>

<style scoped>
  .tabcontent {
    padding-top: 45px;
  }
</style>